export const bookingStatusCodes = {
  cancelled: 'bookingStatusCodeA'
}
